import React from 'react';

import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';

interface IProps {
  withProfileLink?: boolean;
}

export const AccessDenied: React.FC<IProps> = ({ withProfileLink = true }) => {
  const commonT = useTranslation(NSKeys.common);
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title={commonT.t('noAccess')}
      subTitle={commonT.t('noAccessDescription')}
      extra={
        withProfileLink && (
          <Button type="primary" onClick={() => navigate('/dashboard/profile')}>
            {commonT.t('goToProfile')}
          </Button>
        )
      }
    />
  );
};
